/**
 * Created by Michał Stawski on 02.04.2019.
 */
import Paper from '@material-ui/core/Paper'
import React from 'react'
import { connect } from 'react-redux'
import { clientAction } from '../../reducers/restApi'
import { Typography, withStyles, withWidth } from '@material-ui/core'
import { Field, reduxForm, reset, SubmissionError } from 'redux-form'
import { Select, TextField } from 'redux-form-material-ui-adapter'
import { cleanValues } from '../../reducers/schema'
import { CLIENT_ACTION_SUCCESS } from 'redux-coreapi'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import { required, url } from 'redux-form-validators'
import Button from '@material-ui/core/Button'
import moment from 'moment'

const req = required()
const url_blank = url({ allowBlank: true })

const styles = theme => ({
  formStyle: {
    margin: 20
  },
  commentStyle: {
    margin: 10
  },
  DoYouWantTo: {
    padding: 20,
    textAlign: 'center',
  }

})

const fields = [
  { name: 'name', component: TextField, label: 'Name', validate: [req] },
  { name: 'content', component: TextField, label: 'Comment', validate: [req], props: { multiline: true } },
  { name: 'link', component: TextField, label: 'Link', validate: [url_blank] },
]

class CommentsForArticle extends React.Component {
  componentDidMount () {
    this.props.listComments(this.props.articleSubsegment)
  }

  componentDidUpdate (prevProps, prevState, prevContext) {
    if (prevProps.articleSubsegment !== this.props.articleSubsegment) {
      this.props.listComments(prevProps.articleSubsegment)
    }
  }

  render () {
    let {
      classes,
      // files,
      // directory,
      // width,
      // theme,
      handleSubmit,
      invalid, submitting,
      schema,
      comments,
      className,
      // articleSubsegment,
      showLink = false
      // ...props
    } = this.props

    return <Paper className={className}>
      <Typography variant='h5' className={classes.DoYouWantTo}>
        DO YOU HAVE SOME THOUGHTS OR QUESTIONS YOU WOULD LIKE TO SHARE WITH US?
      </Typography>

      {/*comments for {articleSubsegment}*/}
      <form className={classes.formStyle}>
        {fields.map(field => {
            if (field.name === 'link' && !showLink) {
              return ''
            }

            return <FormControl fullWidth key={field.name}>
              {field.component === Select ?
                <InputLabel>{field.label}</InputLabel> : ''
              }
              <Field margin="dense" fullWidth
                     key={field.name}
                     component={field.component}
                     name={field.name}
                     label={field.label}
                     validate={field.validate}
                     {...field.props}
              >
                {schema && field.childrenGenerator ? field.childrenGenerator(this.props) : field.children}
              </Field>
            </FormControl>
          }
        )}

        <Button
          disabled={invalid || submitting}
          color="primary" variant="contained"
          onClick={handleSubmit}
        >
          Add Comment
        </Button>
      </form>
      <div>
        {comments && comments.index && comments.index.map(i => {
          let item = comments.data[i].instance

          return <div key={item.id} className={classes.commentStyle}>
            <Typography variant={'h6'}>
              {item.name}
            </Typography>
            <Typography variant={'caption'}>
              {moment(item.created).format('d MMM YYYY hh:mm')}
            </Typography>
            <Typography variant={'body1'}>
              {item.content}
            </Typography>
            {showLink && item.link && <Typography variant={'subtitle2'}>
              <a href={item.link}> {item.link}</a>
            </Typography>}
          </div>
        })

        }
      </div>
    </Paper>
  }
}

const onSubmit = (values, dispatch, props) => {
  dispatch((dispatch, getState) => {
    let sub
    values = { ...values }
    let state = getState()
    values.article_subsegment = props.articleSubsegment
    try {
      let objectType = 'comments'
      if (values && values.id) {
        console.log('why are You here')
        cleanValues(values, state, objectType, 'update')
        sub = dispatch(clientAction([objectType, 'update'], values))
      } else {
        cleanValues(values, state, objectType, 'create')
        sub = dispatch(clientAction([objectType, 'create'], values))
      }
      if (sub.type) {
        console.error(sub)
      } else {
        sub.then(
          success => {
            if (success.type === CLIENT_ACTION_SUCCESS) {
              dispatch(reset('commentSubmitForm'))
              // props.handleClose()
            } else {
              // dispatch(openSnackbar({message: 'Save Problem', autoHideDuration: 5000}));
              throw new SubmissionError('Save Problem')
            }
          }
        )
      }
    } catch (e) {
      console.error(e)
      throw new SubmissionError(e.validationErrors)
    }
  })
}
export default connect(
  (state) => (
    {
      schema: state.schema.schema,
      comments: state.restApi.comments,
    }
  ),

  (dispatch) => ({
    listComments: (id) => dispatch(clientAction(['comments', 'list'], {
      article_subsegment__id: id
    })),

  })
)(withWidth()(withStyles(styles)(
  reduxForm({
    /** @namespace state.form.commentSubmitForm **/
    form: 'commentSubmitForm',
    enableReinitialize: false,
    onSubmit
  })(CommentsForArticle))
))
